<template>
  <div>
    <!-- LOADING -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      height="6"
      rounded
    />

    <!-- TEXTO -->
    <div v-else>
      <span v-if="resolvedText !== null && resolvedText !== undefined">
        {{ resolvedText }}
      </span>
      <span v-else class="grey--text text--darken-1">
        —
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VEndpointText',
  props: {
    urlGet: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false,
    resolvedText: null
  }),
  watch: {
    urlGet: {
      immediate: true,
      handler(newUrl) {
        this.fetchText(newUrl);
      }
    }
  },
  methods: {
    fetchText(url) {
      if (!url || url.length === 0) {
        this.resolvedText = null;
        return;
      }

      this.loading = true;

      axios
        .get(url)
        .then(response => {
          // Se muestra TAL CUAL lo que regresa el backend
          this.resolvedText = response.data;
        })
        .catch(error => {
          console.error(error);
          this.resolvedText = null;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>
